









































































import {Component, Vue} from 'vue-property-decorator';
import {dataService} from '@/services/data.service';
import moment from 'moment';

@Component
export default class Abschluss extends Vue {
    private gesellschaft: string = '';
    private successDialog: boolean = true;
    private success: boolean = true;
    private logo: string = '';

    private mounted() {
        dataService
            .ladeVorgang(this.$route.params.id)
            .then((response: any) => {
                // @ts-ignore
                this.logo = window.origin + this.$router.options.base + '/logo/' + dataService.vorgang.webparams.logo;
                this.success = (dataService.vorgang.einwilligungGesundheitsdaten &&
                    dataService.vorgang.einwilligungDatenweitergabe &&
                    dataService.vorgang.einwilligungEinrichtung);
                this.gesellschaft = dataService.vorgang.vorgangsMetadaten.mandantName;
                this.successDialog = true;
                if (this.success) {
                    setTimeout(() => {
                        this.successDialog = false;
                    }, 1000);
                }
            });
    }

    private pdf() {
        //@ts-ignore;
        const doc = new jsPDF();
        let y = 10;

        doc.setFont('times');
        doc.setFontSize(12);
        doc.setFontType('bold');
        doc.text('Einzelfalleinwilligung zur Prüfung der Leistungspflicht', 50, y);
        doc.setFontType('normal');
        y += 10;
        doc.setDrawColor(211, 211, 211);
        doc.text('Name des Patienten:', 10, y);
        doc.text(dataService.vorgang.patient, 48, y);
        y += 5;
        doc.text('Vorgangsnummer', 10, y);
        doc.text(dataService.vorgang.ranaVorgangsnummer, 48, y);
        y += 10;
        doc.text('1. Abfrage von Gesundheitsdaten bei Dritten zur Prüfung der Leistungspflicht', 10, y);
        const ersterAbsatz = 'Zur Prüfung der Leistungspflicht in Ihrem Versicherungsfall ist es erforderlich,' +
            ' dass die ROLAND Assistance GmbH / ' + this.gesellschaft + ' die Angaben über Ihre gesundheitlichen' +
            ' Verhältnisse prüft, die Sie zur Begründung von Ansprüchen gemacht haben oder die sich aus' +
            ' eingereichten Unterlagen (zum Beispiel Rechnungen, Verordnungen, Gutachten) oder Mitteilungen' +
            ' (zum Beispiel eines Arztes oder sonstigen Angehörigen eines Heilberufs) ergeben. \n' +
            'Die Überprüfung' +
            ' erfolgt nur, soweit es erforderlich ist. Die ROLAND Assistance GmbH / ' + this.gesellschaft +
            ' benötigt hierfür Ihre Einwilligung einschließlich einer Entbindung von der Schweigepflicht für sich,' +
            ' sowie für dritte Stellen für den Fall, dass im Rahmen dieser Abfragen Gesundheitsdaten oder weitere' +
            ' nach § 203 Strafgesetzbuch (StGB) geschützte Informationen weitergegeben werden müssen, um die' +
            ' Umstände der Leistungspflicht in Ihrem Versicherungsfall, insbesondere zu den Umständen Ihres' +
            ' Krankheitsfalls und im Hinblick auf entstehende Kosten, zu prüfen und um die für Sie erforderlichen' +
            ' Leistungen zu organisieren und erbringen zu lassen.\n' +
            'Die für eine Weitergabe infrage kommenden Stellen können Sie unter folgenden Webadressen erfahren:\n\n' +
            'https://www.roland-assistance.de/datenschutz_2/datenschutz.html\n' +
            'https://www.roland-rechtsschutz.de/datenschutz\n\n' +
            'Zudem werden wir Sie, wenn möglich, im Einzelfall darauf hinweisen, an welche weiteren Stellen wir' +
            ' Ihre Daten zur Leistungserbringung weitergeben.\n\n' +
            'Ich willige ein, dass die ROLAND Assistance GmbH / ' + this.gesellschaft + ' – soweit es für' +
            ' die Prüfung der Leistungspflicht in meinem Versicherungsfall sowie zur Organisation der im Einzelfall' +
            ' für mich nötigen Leistungen erforderlich ist – meine Gesundheitsdaten / die Gesundheitsdaten der von' +
            ' mir gesetzlich vertretenen Personen oder meines Kindes, soweit diese die Tragweite dieser' +
            ' Einwilligung nicht erkennen und daher keine eigenen Erklärungen abgeben können, erhebt und zum Zweck' +
            ' der Prüfung der Leistungspflicht sowie zur Organisation der erforderlichen Leistungen verwendet.\n\n' +
            'Ich befreie die genannten Personen oder Mitarbeiter der genannten Einrichtung von ihrer' +
            ' Schweigepflicht, soweit diese zulässigerweise gespeicherten Gesundheitsdaten aus Untersuchungen,' +
            ' Beratungen und Behandlungen sowie Versicherungsanträgen und –verträgen aus einem Zeitraum von bis' +
            ' zu zehn Jahren vor Stellung des Versicherungsantrags an die ROLAND Assistance GmbH /' +
            ' ' + this.gesellschaft + ' übermittelt werden. Ich bin darüber hinaus damit einverstanden,' +
            ' dass in diesem Zusammenhang – soweit erforderlich – diese Gesundheitsdaten durch die ROLAND' +
            ' Assistance GmbH / ' + this.gesellschaft + ' an die genannten sowie weiteren Stellen, wie' +
            ' z. B. den Versicherungsträger weitergegeben werden, deren Einbindung zur Prüfung der' +
            ' Leistungspflicht und zur Organisation und Erbringung der im Einzelfall notwendigen Leistungen' +
            ' erforderlich ist. Ich befreie insoweit die für die ROLAND Assistance GmbH /' +
            ' ' + this.gesellschaft + ' tätigen Personen von ihrer Schweigepflicht.';
        y += 10;
        doc.text(10, y, doc.setFontSize(10).splitTextToSize(ersterAbsatz, 190));

        y += 140;
        doc.setFontSize(12);
        doc.text('2. Abfrage der zu befreienden Einrichtungen', 10, y);

        doc.setFontSize(10);
        y += 10;
        doc.text('Hiermit entbinde ich gegenüber ROLAND Assistance GmbH / ' + this.gesellschaft, 10, y);
        if (dataService.vorgang.einrichtung === 'Alle') {
            y += 8;
            doc.text('alle vorbehandelnden und behandelnden Ärzte und Krankenhausstationen/medizinischen Einrichtungen von der Schweigepflicht', 15, y);
        } else {
            y += 8;
            doc.text('folgende Stellen von der Schweigepflicht', 15, y);
            y += 2;
            dataService.vorgang.einrichtungen.forEach(einrichtung => {
                y += 4;
                doc.text('- ' + einrichtung.name +
                    ', ' + einrichtung.einrichtung +
                    ', ' + einrichtung.ort, 15, y);
            });
        }

        y += 12;
        doc.setFontSize(12);
        doc.text('3. Datenweitergabe zur medizinischen Begutachtung', 10, y);
        const dritterAbsatz = 'Außerdem kann es zur Prüfung der Leistungspflicht notwendig sein, medizinische' +
            ' Gutachter einzuschalten. Die ROLAND Assistance GmbH / ' + this.gesellschaft + ' benötigt Ihre' +
            ' Einwilligung und Schweigepflichtentbindung, wenn in diesem Zusammenhang Ihre Gesundheitsdaten' +
            ' und weitere nach § 203 StGB geschützte Daten übermittelt werden. Aufgrund Ihres Aufenthaltsortes' +
            ' können diese medizinischen Dienstleister auch in einem unsicheren Drittland (nach Art. 49 DSGVO)' +
            ' sitzen. Sie werden über die jeweilige Datenübermittlung unterrichtet.\n\n' +
            'Ich willige ein, dass die ROLAND Assistance GmbH / ' + this.gesellschaft + ' diese Gesundheitsdaten' +
            ' an medizinische Gutachter übermittelt, soweit dies im Rahmen der Prüfung der Leistungspflicht' +
            ' erforderlich ist und diese Gesundheitsdaten dort zweckentsprechend verwendet und die Ergebnisse' +
            ' an die ROLAND Assistance GmbH / ' + this.gesellschaft + ' zurück übermittelt werden.' +
            ' Im Hinblick auf diese Gesundheitsdaten und weitere nach § 203 StGB geschützte Daten entbinde ich' +
            ' die für die ROLAND Assistance GmbH / ' + this.gesellschaft + ' tätigen Personen und die' +
            ' Gutachter von ihrer Schweigepflicht. ';
        y += 10;
        doc.text(10, y, doc.setFontSize(10).splitTextToSize(dritterAbsatz, 190));

        y += 45;
        if (dataService.vorgang.einwilligungQualitaetssicherung) {
            doc.addPage();
            y = 15;
            doc.setFontSize(12);
            doc.text('4. Optionale Einwilligung', 10, y);

            const fuenfterAbsatz = 'Ich willige ein, dass die ROLAND Assistance GmbH im Anschluss an die' +
                ' Leistungsorganisation zu Qualitätszwecken schriftlich Kontakt mit mir aufnehmen darf, um mich' +
                ' zu meiner Zufriedenheit mit den durch die ROLAND Assistance GmbH erbrachten und vermittelten' +
                ' Leistungen zu befragen.\n\n' +
                'Die Teilnahme an einer Befragung bleibt auch nach erteilter Einwilligung freiwillig und kann von' +
                ' mir jederzeit und ohne Angabe von Gründen abgelehnt werden. Hierfür reicht eine Email an:\n\n' +
                'ambulance@roland24.de';
            y += 10;
            doc.text(10, y, doc.setFontSize(10).splitTextToSize(fuenfterAbsatz, 190));
            y += 45;
        }
        doc.setFontSize(10);
        y += 10;
        doc.text('Datum: ' + moment(new Date()).format('DD.MM.YYYY'), 10, y);

        y += 10;
        doc.text('(Dieses Dokument wurde digital erstellt und ist daher auch ohne Unterschrift gültig)', 40, y);

        const datenschutzhinweis = '' +
            'Sie haben das Recht, einer Verarbeitung Ihrer personenbezogenen Daten zu Zwecken der Direktwerbung ' +
            'zu widersprechen.\n' +
            'Verarbeiten wir Ihre Daten zur Wahrung berechtigter Interessen, können Sie dieser Verarbeitung ' +
            'widersprechen, wenn sich aus Ihrer besonderen Situation Gründe ergeben, die gegen die ' +
            'Datenverarbeitung sprechen.\n' +
            'Beruht die Verarbeitung Ihrer personenbezogenen Daten auf einer Einwilligung, können Sie diese ' +
            'jederzeit für zukünftige Zwecke widerrufen. Durch den Widerruf der Einwilligung wird die ' +
            'Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt. ' +
            'Einen Widerruf richten Sie bitte ' +
            'formlos an ambulance@roland24.de.\n' +
            'Weitere Informationen zum Datenschutz finden Sie hier: ' +
            'https://www.roland-assistance.de/notfallhilfe/notfallhilfe_datenschutzhinweise.html';

        //Seitenwechsel
        doc.addPage();
        y = 10;
        doc.setFont('times');
        doc.setFontSize(12);
        doc.setFontType('bold');
        doc.text('Datenschutzhinweis', 50, y);
        doc.setFontType('normal');

        y += 10;
        doc.text(10, y, doc.setFontSize(10).splitTextToSize(datenschutzhinweis, 190));

        doc.save('Einwilligungserklaerung.pdf');
    }

}
